import { MdAirlineSeatIndividualSuite } from "react-icons/md";
import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.documentListItem()
    .schemaType(`suiteCategoryTemplate`)
    .icon(MdAirlineSeatIndividualSuite)
    .id(`suiteCategoryTemplate`)
    .title(`Suite Category Page`);
